import { villageDeleteApi } from "../../api/village/villageDeleteApi"

type PayloadShape = Parameters<typeof villageDeleteApi>[0]

export async function villageDeleteService(payload: PayloadShape, token: string) {
	return await villageDeleteApi(payload, token)
}
